<template>
  <FooterSection ref="footer"></FooterSection>
</template>

<script>
  import FooterSection from "./FooterSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "FooterWrapper",
    components: {
      FooterSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
